import React, { useContext, useEffect } from 'react';
import "../components/style_v2.css"
import "../components/style.css";
import Navbar from '../components/Navbar';
import Carousel from '../components/home/home_Carousel';
import Partners from '../components/home/home_Partners';
import SolutionSection from '../components/home/home_SolutionSection';
import CoreFeatures from '../components/home/home_CoreFeatures';
import SecurityFeatures from '../components/home/home_SecurityFeatures';
import Outsourcing from '../components/home/home_Outsourcing';
import AiProjectsSectionVideo from "../components/product_ai/AiProjectsSectionVideo";
import Topbar from '../components/Topbar';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language, changeLanguage } = useContext(LanguageContext);

  // 🚀 頁面載入就強制切換到 zh-TW
  useEffect(() => {
    changeLanguage("en"); // 👈 統一在這裡指定
  }, []);
  return (
    <div>
      <Topbar />
      <Navbar />
      <Carousel />
      <AiProjectsSectionVideo />
      <Partners />
      <SolutionSection />
      <CoreFeatures />
      <SecurityFeatures />
      <Outsourcing />
    </div>
  );
};

export default Page;